var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 33,
    viewBox: "0 0 36 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26_323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7446 12.089C28.7446 16.4267 27.1017 19.393 25.3044 21.3767C23.2573 23.639 20.9675 26.1873 15.6934 26.5687H7.06737V19.3307H15.4582C17.77 19.3307 19.6701 19.6643 21.188 21.813C21.9562 21.1713 22.6288 20.4343 23.3344 19.657C23.985 18.9383 24.5069 18.15 24.9259 17.314C23.8269 16.5587 22.5773 15.9793 21.868 15.708C24.2239 14.3917 26.2049 12.3237 26.2049 8.60567C26.2049 6.25533 25.4514 4.422 23.9409 2.915C22.0554 1.034 19.0894 0 15.3148 0H-0.000322458V6.347H14.2306C17.2959 6.347 18.9902 7.568 18.9902 9.73133C18.9902 12.2723 16.9651 13.3063 13.7602 13.3063H7.06737H-0.0039978V32.912H15.6897C24.2349 32.912 28.5718 27.4597 30.608 25.179C33.2101 22.2603 35.996 17.6843 35.996 10.9963V9.90733H28.7372V12.0817L28.7446 12.089Z",
    fill: "#202D59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2401 27.3717C31.4168 28.3067 30.2701 29.5974 28.7449 30.8771V32.9964H36.0037V22.0551C35.0922 23.8004 33.9528 25.4541 32.5672 27.0014L32.2401 27.3717Z",
    fill: "#55B56C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.105 2.38334C27.804 4.49167 28.1164 7.03634 29.7997 8.07034C31.483 9.10434 33.9014 8.23167 35.1988 6.12334C36.4998 4.01501 36.1874 1.47034 34.5041 0.43634C32.8208 -0.59766 30.4024 0.275007 29.105 2.38334Z",
    fill: "#55B56C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.494dfea6a190c5bc586e10acedf226e7.svg";
export { ForwardRef as ReactComponent };